//----------new menu work
import React, { useEffect, useRef, useState } from "react";
import { Avatar, Modal, Popover } from "antd";
import { Link, useNavigate } from "react-router-dom";
import tutifyLogo from "../../assets/images/tutifyLogo.png";
import SignUp from "../signUp";
import LogIn from "../login";
import UserIcon from "../../assets/images/user-icon.png";
import { AiOutlineSearch } from "react-icons/ai";
import styles from "./style.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  clearLocalStorage,
  convertTo12HourFormat,
  formatDate,
  formatMessage,
} from "../../helper";
import { deleteUser } from "../../redux/slice/auth/authSlice";
import { HOME_URL, TEACHER_ROLE } from "../../constants";
import { BiLogOutCircle } from "react-icons/bi";
import { CiSettings } from "react-icons/ci";
import { BiBell, BiSolidUserCircle, BiEnvelope } from "react-icons/bi";
import CustomModal from "../modal";
import Chat from "../chat/chat";
import { firestore } from "../../firebase/config";
import HeaderLogo from "../header-logo";
import Menus from "../menus";
import HeaderSearch from "../header-search";

const Header = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const { meetings, listLoading } = useSelector((state) => state?.userMeetings);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState();
  const collapseRef = useRef(null);
  const [openSignUp, setOpenSignUp] = useState(false);
  const [openLogIn, setOpenLogIn] = useState(false);
  const [scrolling, setScrolling] = useState(false);

  const [messageLoading, setMessageLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [messageSeen, setMessageSeen] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [openMessageModal, setOpenMessageModal] = useState({
    itemDetail: "",
    open: false,
  });

  const addRoleCharInUserId = (userId) => {
    let id;
    if (loggedInUser?.role === TEACHER_ROLE && loggedInUser?.id === userId) {
      // id = `${userId}T`;
      id = userId;
    } else {
      // id = `${userId}S`;
      id = userId;
    }
    return id;
  };

  useEffect(() => {
    async function getChatDataForUserWithLastMessage(userId, callback) {
      try {
        // console.log(userId);
        const senderQuery = firestore
          .collection("chats")
          .where("senderId", "==", userId);
        const receiverQuery = firestore
          .collection("chats")
          .where("receiverId", "==", userId);
        const unsubscribeSender = senderQuery.onSnapshot((senderSnapshot) => {
          const senderChats = senderSnapshot.docs.map((doc) => ({
            chatId: doc.id,
            lastMessage: doc.data().lastMessage,
          }));
          callback([...senderChats]);
          setMessageSeen(false);
        });
        const unsubscribeReceiver = receiverQuery.onSnapshot(
          (receiverSnapshot) => {
            const receiverChats = receiverSnapshot.docs.map((doc) => ({
              chatId: doc.id,
              lastMessage: doc.data().lastMessage,
            }));
            callback([...receiverChats]);
            setMessageSeen(false);
            setMessageLoading(false);
          }
        );
        // Returning the unsubscribe functions in case you want to stop listening to changes later
        return {
          unsubscribeSender,
          unsubscribeReceiver,
        };
      } catch (error) {
        console.error("Error getting chat data for user:", error);
        setMessageLoading(false);
        throw error;
      }
    }
    // Example usage
    if (loggedInUser?.uuid) {
      getChatDataForUserWithLastMessage(loggedInUser?.uuid, (chats) => {
        const sortedChats = chats.sort(
          (b, a) =>
            b.lastMessage.timestamp.seconds - a.lastMessage.timestamp.seconds
        );
        // console.log(sortedChats);
        setMessages(sortedChats);
      });
    }
  }, [loggedInUser?.uuid]);

  const messageList = (list, loading) => {
    return (
      <div>
        {loading ? (
          <div>Loading...</div>
        ) : list?.length ? (
          <div className={`${styles.meetings}`}>
            <BiEnvelope size={25} className="me-2" />
            <b>Messages {`(${list?.length})`}</b>
            <hr />
            {list
              ?.slice()
              ?.reverse()
              ?.map((item) => {
                return (
                  <div
                    onClick={() => handleMessageModal2(true, item)}
                    key={item?.chatId}
                    className={` mb-2 cursor_pointer ${styles.itemWidth}`}
                  >
                    <div className="d-flex">
                      <div className={`${styles.singleMeeting} me-3 mt-2`}>
                        <BiEnvelope color="white" size={20} />
                      </div>
                      <div className="flex-column d-flex">
                        <span>
                          Message From
                          <b>
                            <i>
                              {" "}
                              {item?.lastMessage?.receiverId ===
                              addRoleCharInUserId(loggedInUser?.uuid)
                                ? item?.lastMessage?.senderName
                                : item?.lastMessage?.receiverName}
                            </i>
                          </b>
                        </span>
                        <span style={{ color: "gray" }}>
                          {formatDate(
                            item?.lastMessage?.timestamp.seconds * 1000
                          )}
                        </span>
                        {/* <span style={{ color: "gray" }}>
                          {convertTo12HourFormat(item?.startTime)} -{" "}
                          {convertTo12HourFormat(item?.endTime)}
                        </span> */}
                        <span>{formatMessage(item?.lastMessage?.text, 5)}</span>
                      </div>
                    </div>

                    <hr />
                  </div>
                );
              })}
          </div>
        ) : (
          <div>No Notification to show</div>
        )}
      </div>
    );
  };

  const meetingList = (list, loading) => {
    return (
      <div>
        {loading ? (
          <div>Loading...</div>
        ) : list?.length ? (
          <div className={`${styles.meetings}`}>
            <BiBell size={25} className="me-2" />
            <b>Notifications {`(${list?.length})`}</b>
            <hr />
            {list
              ?.slice()
              ?.reverse()
              ?.map((item) => {
                return (
                  <div
                    onClick={() => handleMessageModal(true, item)}
                    key={item?.id}
                    className={` mb-2 cursor_pointer ${styles.itemWidth}`}
                  >
                    <div className="d-flex">
                      <div className={`${styles.singleMeeting} me-3 mt-2`}>
                        <BiBell color="white" size={20} />
                      </div>
                      <div className="flex-column d-flex">
                        <span>
                          Meeting with
                          <b>
                            <i> {item?.user?.fullName}</i>
                          </b>
                        </span>

                        <span style={{ color: "gray" }}>
                          {formatDate(item?.date)}
                        </span>
                        <span style={{ color: "gray" }}>
                          {convertTo12HourFormat(item?.startTime)} -{" "}
                          {convertTo12HourFormat(item?.endTime)}
                        </span>
                        <span>{formatMessage(item?.message, 5)}</span>
                      </div>
                    </div>

                    <hr />
                  </div>
                );
              })}
          </div>
        ) : (
          <div>No Notification to sho</div>
        )}
      </div>
    );
  };
  const menus = [
    {
      id: 1,
      name: "Home",
      link: "/",
      isBold: "bold",
    },
    {
      id: 2,
      name: "Find a Teacher",
      link: "",
      isBold: "",
    },
    {
      id: 3,
      name: "Become a Teacher",
      link: "",
      isBold: "",
    },
    {
      id: 4,
      name: "Free Learnding",
      link: "",
      isBold: "",
    },
    {
      id: 5,
      name: "Scholerships",
      link: "",
      isBold: "",
    },
    {
      id: 6,
      name: "Community Service",
      link: "",
      isBold: "",
    },
    {
      id: 7,
      name: "Advertise With Us",
      link: "",
      isBold: "",
    },
    {
      id: 8,
      name: "Invertor Relation",
      link: "",
      isBold: "",
    },
    {
      id: 9,
      name: "Merchendise",
      link: "",
      isBold: "",
    },
    {
      id: 10,
      name: "Blogs",
      link: "",
      isBold: "",
    },
    {
      id: 11,
      name: "Contact Us",
      link: "",
      isBold: "",
    },
    {
      id: 12,
      name: "About Us",
      link: "",
      isBold: "",
    },
  ];

  // useEffect(() => {
  //   if (loggedInUser?.id && !teacherMeetings?.length) {
  //     getAllTeacherMeetings(loggedInUser);
  //   }
  // }, [loggedInUser]);

  useEffect(() => {
    // Function to handle scroll events
    const handleScroll = () => {
      if (window.scrollY > 0) {
        // User has scrolled down, add classes
        setScrolling(true);
      } else {
        // User has scrolled to the top, remove classes
        setScrolling(false);
      }
    };

    // Add the scroll event listener when the component mounts
    window.addEventListener("scroll", handleScroll);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMessageModal = (status, item) => {
    setOpenMessageModal({
      open: status,
      itemDetail: {
        ...item,
        // id:
        //   loggedInUser?.role === TEACHER_ROLE
        //     ? item?.studentId
        //     : item?.teacherId,
        uuid: item?.user?.uuid,
        fullName: item?.user?.fullName,
      },
    });
  };

  const handleMessageModal2 = (status, item) => {
    setOpenMessageModal({
      open: status,
      itemDetail: {
        ...item,
        // id:
        //   loggedInUser?.role === TEACHER_ROLE
        //     ? item?.studentId
        //     : item?.teacherId,
        uuid:
          item?.lastMessage?.receiverId ===
          addRoleCharInUserId(loggedInUser?.uuid)
            ? item?.lastMessage?.senderId
            : item?.lastMessage?.receiverId,
        fullName:
          item?.lastMessage?.receiverId ===
          addRoleCharInUserId(loggedInUser?.uuid)
            ? item?.lastMessage?.senderName
            : item?.lastMessage?.receiverName,
      },
    });
  };

  const handleItemClick = (itemId) => {
    setActiveItem(itemId);
    // Programmatically close the mobile menu
    if (collapseRef.current) {
      collapseRef.current.classList.remove("show");
    }
  };

  const handleSignUpModal = (status) => {
    setOpenSignUp(status);
    setOpenModal(status);
    setOpenLogIn(false);
  };

  const handleLogInModal = (status) => {
    setOpenModal(status);
    setOpenLogIn(status);
    setOpenSignUp(false);
  };

  const handleLogOut = () => {
    clearLocalStorage();
    dispatch(deleteUser());
    navigate(HOME_URL);
  };

  const handleModal = (status) => {
    setOpenModal(status);
    if (!status) {
      if (openSignUp) {
        setOpenModal(false);
      }
      if (openLogIn) {
        setOpenLogIn(false);
      }
    }
  };

  return (
    <div style={{ backgroundColor: "#EFFBFF" }}>
      {/* <Modal

        maskClosable={false}
        width={700}
        footer={null}
        closable
        title=""
        open={openMessageModal?.open}
        onOk={() => handleMessageModal(false, "")}
        onCancel={() => handleMessageModal(false, "")}
        zIndex={1040}
      >
        <Chat receiver={openMessageModal?.itemDetail} />
      </Modal>*/}

      <CustomModal
        style={{
          top: openSignUp ? "15%" : "10%",
        }}
        width={700}
        show={openModal}
        onCancel={() => handleModal(false)}
      >
        {openSignUp ? (
          <SignUp
            openSignUp={openSignUp}
            handleSignUpModal={handleSignUpModal}
          />
        ) : (
          ""
        )}
        {openLogIn ? (
          <LogIn openLogIn={openLogIn} handleLogInModal={handleLogInModal} />
        ) : (
          ""
        )}
        <div className="signUpText mt-3 text-center fs_12">
          {openLogIn ? (
            <p>
              Don't have an account yet?{" "}
              <span
                onClick={() => handleSignUpModal(true)}
                className="link-dark text-decoration-none fw-bold cursor_pointer"
              >
                Sign Up
              </span>
            </p>
          ) : (
            ""
          )}

          {openSignUp ? (
            <p>
              Already have account?{" "}
              <span
                onClick={() => handleLogInModal(true)}
                className="link-dark text-decoration-none fw-bold cursor_pointer"
              >
                Sign In
              </span>
            </p>
          ) : (
            ""
          )}
        </div>
      </CustomModal>

      {/* menu for small devices  star here */}
      <nav className="d-lg-none navbar navbar-expand-lg navbar-light ">
        <div className="container-fluid">
          <HeaderLogo />
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            ref={collapseRef}
            className="collapse navbar-collapse"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li style={{ fontSize: "12px" }} className="nav-item mt-2 mb-1">
                {/* header search input */}
                {/* <HeaderSearch /> */}
              </li>
              {!loggedInUser?.id ? (
                <>
                  <li
                    style={{ fontSize: "12px" }}
                    className="nav-item mt-1 mb-1"
                  >
                    <button
                      onClick={() => handleLogInModal(true)}
                      type="button"
                      className="btn btn-primary  btn-sm me-2 btn_contained_black"
                    >
                      Login
                    </button>
                  </li>
                  <li
                    style={{ fontSize: "12px" }}
                    className="nav-item mt-1 mb-1"
                  >
                    <button
                      onClick={() => handleSignUpModal(true)}
                      type="button"
                      className="btn btn-primary  btn-sm me-2 btn_contained_black"
                    >
                      Sign Up
                    </button>
                  </li>
                </>
              ) : (
                ""
              )}
              <Menus />
            </ul>
          </div>
        </div>
      </nav>

      {/* menu for small devices end here */}

      {/* menu for large devices start here */}

      <div
        className={`d-none d-lg-block pe-5 px-5
        
        `}
        style={{ backgroundColor: "#EFFBFF" }}
      >
        <div
          style={{ paddingLeft: "22px", paddingRight: "28px" }}
          className="justify-content-between d-flex  pb-1 pt-4"
        >
          <HeaderLogo />

          <nav className={`navbar navbar-expand-lg navbar-light`}>
            {/* <div className="container-fluid pe-3 px-3"> */}
            <div
              className="collapse navbar-collapse justify-content-start"
              id="navbarSupportedContent"
            >
              <ul
                className="navbar-nav"
                // style={{ margin: "0 auto" }}
                style={{ margin: "-5px 560px -10px 0px" }}
              >
                <Menus />
              </ul>
            </div>
            {/* </div> */}
          </nav>

          <div className="justify-content-between d-flex">
            {/* header search input */}
            {/* <HeaderSearch /> */}
            {!loggedInUser?.id ? (
              <>
                <button
                  onClick={() => handleLogInModal(true)}
                  type="button"
                  className="btn btn-primary btn-sm me-2 btn_contained_black"
                >
                  Login
                </button>
                <button
                  onClick={() => handleSignUpModal(true)}
                  type="button"
                  className="btn btn-primary  btn-sm me-2 btn_contained_black"
                >
                  Sign Up
                </button>
              </>
            ) : (
              ""
            )}
          </div>
        </div>

        {scrolling ? (
          <nav
            className={`navbar navbar-expand-lg navbar-light
           ${scrolling ? `fixed-top bg-white shadow` : ""}
          `}
          >
            <div className="container-fluid pe-3 px-3">
              <div
                className="collapse navbar-collapse justify-content-start"
                id="navbarSupportedContent"
              >
                {scrolling ? <HeaderLogo /> : ""}
                <ul
                  className="navbar-nav mb-2 mb-lg-0"
                  // style={{ margin: "0 auto" }}
                  style={{ margin: "0 auto -10px 20px" }}

                  // style={{ margin: "-5px 200px -10px 0px" }}
                >
                  <Menus />
                </ul>
              </div>

              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex bg-white me-2 shadow-sm">
                  <input
                    type="search"
                    className="form-control fs_12 border-0 form_control_focus_box_shadow_none "
                    placeholder="Search"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                  />
                  <AiOutlineSearch className={`${styles.searhIcon}`} />
                </div>
                {!loggedInUser?.id ? (
                  <>
                    <button
                      onClick={() => handleLogInModal(true)}
                      type="button"
                      className="btn btn-primary  btn-sm me-2 btn_contained_black"
                    >
                      Login
                    </button>
                    <button
                      onClick={() => handleSignUpModal(true)}
                      type="button"
                      className="btn btn-primary  btn-sm me-2 btn_contained_black"
                    >
                      Sign Up
                    </button>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </nav>
        ) : null}
      </div>
      {/* menu for large devices end here */}
    </div>
  );
};

export default Header;

//----------old menu work
// import React, { useEffect, useRef, useState } from "react";
// import { Avatar, Modal, Popover } from "antd";
// import { Link, useNavigate } from "react-router-dom";
// import tutifyLogo from "../../assets/images/tutifyLogo.png";
// import SignUp from "../signUp";
// import LogIn from "../login";
// import UserIcon from "../../assets/images/user-icon.png";
// import { AiOutlineSearch } from "react-icons/ai";
// import styles from "./style.module.css";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   clearLocalStorage,
//   convertTo12HourFormat,
//   formatDate,
//   formatMessage,
// } from "../../helper";
// import { deleteUser } from "../../redux/slice/auth/authSlice";
// import { HOME_URL, TEACHER_ROLE } from "../../constants";
// import { BiLogOutCircle } from "react-icons/bi";
// import { CiSettings } from "react-icons/ci";
// import { BiBell, BiSolidUserCircle, BiEnvelope } from "react-icons/bi";
// import CustomModal from "../modal";
// import Chat from "../chat/chat";
// import { firestore } from "../../firebase/config";
// import HeaderLogo from "../header-logo";
// import Menus from "../menus";

// const Header = () => {
//   const loggedInUser = useSelector((state) => state.auth.user);
//   const { meetings, listLoading } = useSelector((state) => state?.userMeetings);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [activeItem, setActiveItem] = useState();
//   const collapseRef = useRef(null);
//   const [openSignUp, setOpenSignUp] = useState(false);
//   const [openLogIn, setOpenLogIn] = useState(false);
//   const [scrolling, setScrolling] = useState(false);

//   const [messageLoading, setMessageLoading] = useState(true);
//   const [messages, setMessages] = useState([]);
//   const [messageSeen, setMessageSeen] = useState(false);
//   const [openModal, setOpenModal] = useState(false);

//   const [openMessageModal, setOpenMessageModal] = useState({
//     itemDetail: "",
//     open: false,
//   });

//   const content = (
//     <div>
//       <p className="cursor_pointer">
//         <BiSolidUserCircle size={20} /> {loggedInUser?.fullName}
//       </p>
//       <p className="cursor_pointer">
//         {" "}
//         <CiSettings size={20} /> Setting
//       </p>
//       <p onClick={() => handleLogOut()} className="cursor_pointer">
//         <BiLogOutCircle size={20} /> Logout
//       </p>
//     </div>
//   );

//   const addRoleCharInUserId = (userId) => {
//     let id;
//     if (loggedInUser?.role === TEACHER_ROLE && loggedInUser?.id === userId) {
//       // id = `${userId}T`;
//       id = userId;
//     } else {
//       // id = `${userId}S`;
//       id = userId;
//     }
//     return id;
//   };

//   useEffect(() => {
//     async function getChatDataForUserWithLastMessage(userId, callback) {
//       try {
//         // console.log(userId);
//         const senderQuery = firestore
//           .collection("chats")
//           .where("senderId", "==", userId);
//         const receiverQuery = firestore
//           .collection("chats")
//           .where("receiverId", "==", userId);
//         const unsubscribeSender = senderQuery.onSnapshot((senderSnapshot) => {
//           const senderChats = senderSnapshot.docs.map((doc) => ({
//             chatId: doc.id,
//             lastMessage: doc.data().lastMessage,
//           }));
//           callback([...senderChats]);
//           setMessageSeen(false);
//         });
//         const unsubscribeReceiver = receiverQuery.onSnapshot(
//           (receiverSnapshot) => {
//             const receiverChats = receiverSnapshot.docs.map((doc) => ({
//               chatId: doc.id,
//               lastMessage: doc.data().lastMessage,
//             }));
//             callback([...receiverChats]);
//             setMessageSeen(false);
//             setMessageLoading(false);
//           }
//         );
//         // Returning the unsubscribe functions in case you want to stop listening to changes later
//         return {
//           unsubscribeSender,
//           unsubscribeReceiver,
//         };
//       } catch (error) {
//         console.error("Error getting chat data for user:", error);
//         setMessageLoading(false);
//         throw error;
//       }
//     }
//     // Example usage
//     if (loggedInUser?.uuid) {
//       getChatDataForUserWithLastMessage(loggedInUser?.uuid, (chats) => {
//         const sortedChats = chats.sort(
//           (b, a) =>
//             b.lastMessage.timestamp.seconds - a.lastMessage.timestamp.seconds
//         );
//         // console.log(sortedChats);
//         setMessages(sortedChats);
//       });
//     }
//   }, [loggedInUser?.uuid]);

//   const messageList = (list, loading) => {
//     return (
//       <div>
//         {loading ? (
//           <div>Loading...</div>
//         ) : list?.length ? (
//           <div className={`${styles.meetings}`}>
//             <BiEnvelope size={25} className="me-2" />
//             <b>Messages {`(${list?.length})`}</b>
//             <hr />
//             {list
//               ?.slice()
//               ?.reverse()
//               ?.map((item) => {
//                 return (
//                   <div
//                     onClick={() => handleMessageModal2(true, item)}
//                     key={item?.chatId}
//                     className={` mb-2 cursor_pointer ${styles.itemWidth}`}
//                   >
//                     <div className="d-flex">
//                       <div className={`${styles.singleMeeting} me-3 mt-2`}>
//                         <BiEnvelope color="white" size={20} />
//                       </div>
//                       <div className="flex-column d-flex">
//                         <span>
//                           Message From
//                           <b>
//                             <i>
//                               {" "}
//                               {item?.lastMessage?.receiverId ===
//                               addRoleCharInUserId(loggedInUser?.uuid)
//                                 ? item?.lastMessage?.senderName
//                                 : item?.lastMessage?.receiverName}
//                             </i>
//                           </b>
//                         </span>
//                         <span style={{ color: "gray" }}>
//                           {formatDate(
//                             item?.lastMessage?.timestamp.seconds * 1000
//                           )}
//                         </span>
//                         {/* <span style={{ color: "gray" }}>
//                           {convertTo12HourFormat(item?.startTime)} -{" "}
//                           {convertTo12HourFormat(item?.endTime)}
//                         </span> */}
//                         <span>{formatMessage(item?.lastMessage?.text, 5)}</span>
//                       </div>
//                     </div>

//                     <hr />
//                   </div>
//                 );
//               })}
//           </div>
//         ) : (
//           <div>No Notification to show</div>
//         )}
//       </div>
//     );
//   };

//   const meetingList = (list, loading) => {
//     return (
//       <div>
//         {loading ? (
//           <div>Loading...</div>
//         ) : list?.length ? (
//           <div className={`${styles.meetings}`}>
//             <BiBell size={25} className="me-2" />
//             <b>Notifications {`(${list?.length})`}</b>
//             <hr />
//             {list
//               ?.slice()
//               ?.reverse()
//               ?.map((item) => {
//                 return (
//                   <div
//                     onClick={() => handleMessageModal(true, item)}
//                     key={item?.id}
//                     className={` mb-2 cursor_pointer ${styles.itemWidth}`}
//                   >
//                     <div className="d-flex">
//                       <div className={`${styles.singleMeeting} me-3 mt-2`}>
//                         <BiBell color="white" size={20} />
//                       </div>
//                       <div className="flex-column d-flex">
//                         <span>
//                           Meeting with
//                           <b>
//                             <i> {item?.user?.fullName}</i>
//                           </b>
//                         </span>

//                         <span style={{ color: "gray" }}>
//                           {formatDate(item?.date)}
//                         </span>
//                         <span style={{ color: "gray" }}>
//                           {convertTo12HourFormat(item?.startTime)} -{" "}
//                           {convertTo12HourFormat(item?.endTime)}
//                         </span>
//                         <span>{formatMessage(item?.message, 5)}</span>
//                       </div>
//                     </div>

//                     <hr />
//                   </div>
//                 );
//               })}
//           </div>
//         ) : (
//           <div>No Notification to show</div>
//         )}
//       </div>
//     );
//   };
//   const menus = [
//     {
//       id: 1,
//       name: "Home",
//       link: "/",
//       isBold: "bold",
//     },
//     {
//       id: 2,
//       name: "Find a Teacher",
//       link: "",
//       isBold: "",
//     },
//     {
//       id: 3,
//       name: "Become a Teacher",
//       link: "",
//       isBold: "",
//     },
//     {
//       id: 4,
//       name: "Free Learnding",
//       link: "",
//       isBold: "",
//     },
//     {
//       id: 5,
//       name: "Scholerships",
//       link: "",
//       isBold: "",
//     },
//     {
//       id: 6,
//       name: "Community Service",
//       link: "",
//       isBold: "",
//     },
//     {
//       id: 7,
//       name: "Advertise With Us",
//       link: "",
//       isBold: "",
//     },
//     {
//       id: 8,
//       name: "Invertor Relation",
//       link: "",
//       isBold: "",
//     },
//     {
//       id: 9,
//       name: "Merchendise",
//       link: "",
//       isBold: "",
//     },
//     {
//       id: 10,
//       name: "Blogs",
//       link: "",
//       isBold: "",
//     },
//     {
//       id: 11,
//       name: "Contact Us",
//       link: "",
//       isBold: "",
//     },
//     {
//       id: 12,
//       name: "About Us",
//       link: "",
//       isBold: "",
//     },
//   ];

//   // useEffect(() => {
//   //   if (loggedInUser?.id && !teacherMeetings?.length) {
//   //     getAllTeacherMeetings(loggedInUser);
//   //   }
//   // }, [loggedInUser]);

//   useEffect(() => {
//     // Function to handle scroll events
//     const handleScroll = () => {
//       if (window.scrollY > 0) {
//         // User has scrolled down, add classes
//         setScrolling(true);
//       } else {
//         // User has scrolled to the top, remove classes
//         setScrolling(false);
//       }
//     };

//     // Add the scroll event listener when the component mounts
//     window.addEventListener("scroll", handleScroll);

//     // Remove the event listener when the component unmounts
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   const handleMessageModal = (status, item) => {
//     setOpenMessageModal({
//       open: status,
//       itemDetail: {
//         ...item,
//         // id:
//         //   loggedInUser?.role === TEACHER_ROLE
//         //     ? item?.studentId
//         //     : item?.teacherId,
//         uuid: item?.user?.uuid,
//         fullName: item?.user?.fullName,
//       },
//     });
//   };

//   const handleMessageModal2 = (status, item) => {
//     setOpenMessageModal({
//       open: status,
//       itemDetail: {
//         ...item,
//         // id:
//         //   loggedInUser?.role === TEACHER_ROLE
//         //     ? item?.studentId
//         //     : item?.teacherId,
//         uuid:
//           item?.lastMessage?.receiverId ===
//           addRoleCharInUserId(loggedInUser?.uuid)
//             ? item?.lastMessage?.senderId
//             : item?.lastMessage?.receiverId,
//         fullName:
//           item?.lastMessage?.receiverId ===
//           addRoleCharInUserId(loggedInUser?.uuid)
//             ? item?.lastMessage?.senderName
//             : item?.lastMessage?.receiverName,
//       },
//     });
//   };

//   const handleItemClick = (itemId) => {
//     setActiveItem(itemId);
//     // Programmatically close the mobile menu
//     if (collapseRef.current) {
//       collapseRef.current.classList.remove("show");
//     }
//   };

//   const handleSignUpModal = (status) => {
//     setOpenSignUp(status);
//     setOpenModal(status);
//     setOpenLogIn(false);
//   };

//   const handleLogInModal = (status) => {
//     setOpenModal(status);
//     setOpenLogIn(status);
//     setOpenSignUp(false);
//   };

//   const handleLogOut = () => {
//     clearLocalStorage();
//     dispatch(deleteUser());
//     navigate(HOME_URL);
//   };

//   const handleModal = (status) => {
//     setOpenModal(status);
//     if (!status) {
//       if (openSignUp) {
//         setOpenModal(false);
//       }
//       if (openLogIn) {
//         setOpenLogIn(false);
//       }
//     }
//   };

//   return (
//     <div style={{ backgroundColor: "#EFFBFF" }}>
//       {/* <Modal

//         maskClosable={false}
//         width={700}
//         footer={null}
//         closable
//         title=""
//         open={openMessageModal?.open}
//         onOk={() => handleMessageModal(false, "")}
//         onCancel={() => handleMessageModal(false, "")}
//         zIndex={1040}
//       >
//         <Chat receiver={openMessageModal?.itemDetail} />
//       </Modal>*/}

//       <CustomModal
//         style={{
//           top: 20,
//         }}
//         width={700}
//         show={openModal}
//         onCancel={() => handleModal(false)}
//       >
//         {openSignUp ? (
//           <SignUp
//             openSignUp={openSignUp}
//             handleSignUpModal={handleSignUpModal}
//           />
//         ) : (
//           ""
//         )}
//         {openLogIn ? (
//           <LogIn openLogIn={openLogIn} handleLogInModal={handleLogInModal} />
//         ) : (
//           ""
//         )}
//         <div className="signUpText mt-3 text-center fs_12">
//           {openLogIn ? (
//             <p>
//               Don't have an account yet?{" "}
//               <span
//                 onClick={() => handleSignUpModal(true)}
//                 className="link-dark text-decoration-none fw-bold cursor_pointer"
//               >
//                 Sign Up
//               </span>
//             </p>
//           ) : (
//             ""
//           )}

//           {openSignUp ? (
//             <p>
//               Already have account?{" "}
//               <span
//                 onClick={() => handleLogInModal(true)}
//                 className="link-dark text-decoration-none fw-bold cursor_pointer"
//               >
//                 Sign In
//               </span>
//             </p>
//           ) : (
//             ""
//           )}
//         </div>
//       </CustomModal>

//       {/* menu for small devices  star here */}
//       <nav className="d-lg-none navbar navbar-expand-lg navbar-light ">
//         <div className="container-fluid">
//           <HeaderLogo />
//           <button
//             className="navbar-toggler"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#navbarSupportedContent"
//             aria-controls="navbarSupportedContent"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//           >
//             <span className="navbar-toggler-icon"></span>
//           </button>
//           <div
//             ref={collapseRef}
//             className="collapse navbar-collapse"
//             id="navbarSupportedContent"
//           >
//             <ul className="navbar-nav me-auto mb-2 mb-lg-0">
//               <li style={{ fontSize: "12px" }} className="nav-item mt-2 mb-1">
//                 <div className="d-flex bg-white me-2">
//                   <input
//                     type="search"
//                     className="form-control fs_12 border-0 form_control_focus_box_shadow_none"
//                     placeholder="Search"
//                     aria-label="Username"
//                     aria-describedby="basic-addon1"
//                   />
//                   <AiOutlineSearch className={`${styles.searhIcon}`} />
//                 </div>
//               </li>
//               {!loggedInUser?.id ? (
//                 <>
//                   <li
//                     style={{ fontSize: "12px" }}
//                     className="nav-item mt-1 mb-1"
//                   >
//                     <button
//                       onClick={() => handleLogInModal(true)}
//                       type="button"
//                       className="btn btn-primary  btn-sm me-2 btn_contained_black"
//                     >
//                       Login
//                     </button>
//                   </li>
//                   <li
//                     style={{ fontSize: "12px" }}
//                     className="nav-item mt-1 mb-1"
//                   >
//                     <button
//                       onClick={() => handleSignUpModal(true)}
//                       type="button"
//                       className="btn btn-primary  btn-sm me-2 btn_contained_black"
//                     >
//                       Sign Up
//                     </button>
//                   </li>
//                 </>
//               ) : (
//                 ""
//               )}
//               <Menus />
//             </ul>
//           </div>
//         </div>
//       </nav>

//       {/* menu for small devices end here */}

//       {/* menu for large devices start here */}

//       <div
//         className={`d-none d-lg-block pe-5 px-5

//         `}
//         style={{ backgroundColor: "#EFFBFF" }}
//       >
//         <div
//           style={{ paddingLeft: "22px", paddingRight: "28px" }}
//           className="justify-content-between d-flex  pb-1 pt-4"
//         >
//           <HeaderLogo />
//           <div className="justify-content-between d-flex">
//             <div className="d-flex bg-white me-2 shadow-sm">
//               <input
//                 type="search"
//                 className="form-control fs_12 border-0 form_control_focus_box_shadow_none "
//                 placeholder="Search"
//                 aria-label="Username"
//                 aria-describedby="basic-addon1"
//               />
//               <AiOutlineSearch className={`${styles.searhIcon}`} />
//             </div>
//             {!loggedInUser?.id ? (
//               <>
//                 <button
//                   onClick={() => handleLogInModal(true)}
//                   type="button"
//                   className="btn btn-primary  btn-sm me-2 btn_contained_black"
//                 >
//                   Login
//                 </button>
//                 <button
//                   onClick={() => handleSignUpModal(true)}
//                   type="button"
//                   className="btn btn-primary  btn-sm me-2 btn_contained_black"
//                 >
//                   Sign Up
//                 </button>
//               </>
//             ) : (
//               ""
//             )}
//           </div>
//         </div>
//         <nav
//           className={`navbar navbar-expand-lg navbar-light
//            ${scrolling ? `fixed-top bg-white shadow` : ""}
//           `}
//         >
//           <div className="container-fluid pe-3 px-3">
//             <div
//               className="collapse navbar-collapse justify-content-between"
//               id="navbarSupportedContent"
//             >
//               {scrolling ? <HeaderLogo /> : ""}
//               <ul
//                 className="navbar-nav mb-2 mb-lg-0"
//                 style={{ margin: "0 auto" }}
//               >
//                 <Menus />
//               </ul>
//             </div>
//           </div>
//         </nav>
//       </div>
//       {/* menu for large devices end here */}
//     </div>
//   );
// };

// export default Header;
